import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LoginService } from './login.service';
import { Router } from '@angular/router';
import { NotificationService } from '../../shared/toastrservice.service';
import { Validations } from '../../shared/validations';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})

export class LoginComponent {
	
	loginForm: FormGroup;
  	submitted: boolean = false;
  	
	constructor(
		private title:Title,
		public router: Router,
  		private loginService: LoginService,
  		private toastr : NotificationService
	)
	{}

	ngOnInit(){
    	this.title.setTitle("Login");

    	this.loginForm = new FormGroup({
	      email: new FormControl('', [Validators.required, Validators.pattern(Validations.emailPattern)]),
	      password: new FormControl('', [Validators.required,Validators.pattern(Validations.passwordPattern)])
    	});

  let loginData = JSON.parse(localStorage.getItem('loginData'));
    if (loginData) {
      this.router.navigate(['dashboard']);
    }
	}

	submitLoginForm(){
		this.submitted = true;
  		
      var formData = new FormData();
      formData.append("user_type", "admin");
      formData.append("email", this.loginForm.controls.email.value);
      formData.append("password", this.loginForm.controls.password.value);
      formData.append("device_type", "web");

	    if (this.loginForm.valid) {
      this.loginService.login(formData).subscribe(response => {
        let resData = JSON.parse(JSON.stringify(response));

        if(resData.status_code == 200){
          let loginData = {
            id: resData.data.id,
            full_name: resData.data.full_name,
            email: resData.data.email,
            phone_no: resData.data.phone_no,
            profile_picture: resData.data.profile_picture,
            socket_id: resData.data.socket_id,
            reset_token: resData.data.reset_token,
            is_active: resData.data.is_active,
            is_delete: resData.data.is_delete,
            token : resData.data.token  
          }
          localStorage.setItem('loginData', JSON.stringify(loginData));
          this.router.navigate(['dashboard']).then(() => {
            this.toastr.showSuccess("Login successfully.", "Success");
          });
        }
      },
        error => {
        	this.toastr.showError(error.error.error, "Error");
        });

    }
	}
}
